import {
  Box,
  Button,
  InputLabel as MuiInputLabel,
  Tooltip,
  Typography,
} from '@mui/material';
import { useMediaQuery } from '@mui/system';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

interface Props {
  name: string;
  label: string;
  tooltip?: string;
}

function InputLabel({ tooltip, name, label }: Props) {
  const isSmall = useMediaQuery('(max-width: 899.98px)');

  return (
    <MuiInputLabel
      htmlFor={name}
      sx={{
        display: 'flex',
        justifyContent: isSmall ? 'flex-start' : 'space-between',
        alignItems: 'center',
        gap: 1,
      }}>
      <Typography variant="h5">{label}</Typography>
      {!!tooltip && (
        <Tooltip
          title={tooltip}
          arrow
          placement="top"
          enterTouchDelay={0}
          slotProps={{
            popper: {
              modifiers: [
                {
                  name: 'offset',
                  options: {
                    offset: [0, -5],
                  },
                },
              ],
            },
          }}>
          <Box
            component="span"
            sx={{
              my: 'auto',
              display: 'flex',
              alignItems: 'center',
            }}>
            <Button
              type="button"
              variant="text"
              color="inherit"
              disableRipple
              sx={{
                width: 'auto',
                minWidth: 0,
                padding: 0,
                ':hover': {
                  backgroundColor: 'transparent',
                },
              }}>
              <InfoOutlinedIcon
                sx={{ fontSize: isSmall ? 16 : 12 }}
                fontSize="small"
              />
            </Button>
          </Box>
        </Tooltip>
      )}
    </MuiInputLabel>
  );
}

export default InputLabel;
